<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">历史通讯录</vxe-radio>
          </li>
          <li>
            <vxe-radio name="xtabs" label="tab2">系统个人客户</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="account-search-box" style="display: flex;align-items: center;border:none;">
        <vxe-input v-if="selectTab === 'tab1'" style="height: 34px !important" v-model="partyName" type="search"
                   placeholder="姓名"
                   @search-click="search" @keyup.enter.native="search"></vxe-input>
        <vxe-input v-else style="height: 34px !important" v-model="nameOrPhone" type="search" placeholder="姓名或手机号"
                   @search-click="search" @keyup.enter.native="search"></vxe-input>
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
          :loading="loading"
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable1"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="list"
          @current-change="currentChangeEvent"
      >
        <vxe-table-column field="partyName" title="姓名"></vxe-table-column>
        <vxe-table-column field="partyPhone" title="电话号码"></vxe-table-column>
        <vxe-table-column field="opt" title="操作">
          <template slot-scope="{ row }">
            <a style="color: red" @click.stop="commitDelete(row.id)">删除</a>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable2"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="personalData"
          @current-change="currentChangeEvent2"
      >
        <vxe-table-column field="realName" title="姓名"></vxe-table-column>
        <vxe-table-column field="regisiterNum" title="手机号"></vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import getAuthOrization from "@/mixin/getAuthOrization";
import {showLoading, hideLoading} from "@/utils/util";

export default {
  name: "Account",
  mixins: [getAuthOrization],
  data() {
    return {
      loading: false,
      partyName: null,
      list: [],
      isOnlyUser: false,
      isIdCardNum: false,
      payType: 1,
      selectTab: "tab1",
      nameOrPhone: null,
      personalData: []
    };
  },
  created() {
  },
  methods: {
    async queryPerUserList() {
      this.loading = true;
      let res = await $api.gcdUser.request("queryUserListWithoutPermission2", {
        nameOrPhone: this.nameOrPhone,
        userType: 1,
        orderBy: 2,
        page: 1,
        rows: 10,
      });
      this.loading = false;
      if (res.status === 1) {
        this.personalData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    init() {
      this.partyName = null;
      this.nameOrPhone = null;
      this.queryFadadaPhone();
    },
    currentChangeEvent({row}) {
      this.$emit("choose", row);
    },
    currentChangeEvent2({row}) {
      this.$emit("choose", {
        partyId: row.id,
        partyName: row.realName,
        partyPhone: row.regisiterNum
      });
    },
    search() {
      if (this.selectTab === 'tab1') {
        this.queryFadadaPhone();
      } else {
        if (this.nameOrPhone) {
          this.queryPerUserList();
        }
      }
    },
    async queryFadadaPhone() {
      this.loading = true;
      let res = await $api.eleContract.post("queryFadadaPhone", {
        partyName: this.partyName
      });
      this.loading = false;
      if (res.status === 1) {
        this.list = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    commitDelete(id) {
      this.$XModal.confirm("您确定要删除吗？").then(type => {
        if (type === "confirm") {
          this.deleteFadadaPhone(id);
        }
      });
    },
    async deleteFadadaPhone(id) {
      showLoading();
      let res = await $api.eleContract.post("deleteFadadaPhone", {
        id: id
      });
      hideLoading();
      if (res.status === 1) {
        this.$XModal.message({message: '删除成功！'});
        this.queryFadadaPhone();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.partyName = null;
      this.$refs.xTable1.clearCurrentRow();
    },
  },
};
</script>

<style lang="css">
.account-search-box {
  position: absolute;
  right: 20px;
  top: 8px;
  height: 36px;
  border: 1px solid #ccc;
  overflow: hidden;
}

.header {
  width: 100%;
  min-height: 44px;
  margin-bottom: 10px;
}
</style>
